import React from 'react';
import s from './JobIcon.module.scss';

const GridCardsIcon2 = () => {
  return (
    <svg className={s.gridCardsIcon2} width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_19_2567)">
      <path d="M50.5381 11.9257L18.9128 6.33796C17.8564 6.15131 16.8505 6.8461 16.6661 7.88981L9.50427 48.4238C9.31986 49.4675 10.0267 50.4649 11.0831 50.6516L42.7085 56.2394C43.7649 56.426 44.7708 55.7312 44.9552 54.6875L52.117 14.1535C52.3014 13.1098 51.5945 12.1124 50.5381 11.9257Z" stroke="white" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M25 17L30.7808 18.0833L41 20" stroke="#41B64D" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M23 26L39 29" stroke="#41B64D" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 36L30 37" stroke="#41B64D" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_19_2567">
      <rect width="62" height="62" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default GridCardsIcon2;